import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Pipe({
    name: 'youtubeSafeUrl',
    standalone: false
})
export class YoutubeSafeUrlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(videoId: string, arg1: any, isQQvideo:boolean = false ): SafeResourceUrl {
        let url = '';
        if (isQQvideo) {
            url = `https://v.qq.com/txp/iframe/player.html?vid=${videoId}`;
            if (arg1 === 'autoplay') {
                url = url + '&autoplay=true';
            }
        } else {
            url = `https://www.youtube.com/embed/${videoId}?rel=0&controls=1&modestbranding=1&showinfo=0&enablejsapi=1`;
            if (arg1 === 'autoplay') {
                url = url + '&autoplay=1&mute=1';
            }
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }


}
